import React from "react";
import CreateVoucherList from "../../views/Vouchers/CreateVoucher/CreateVoucherList";
const CrearVoucher = () => {
  return <CreateVoucherList />;
};

export default CrearVoucher;
